// extracted by mini-css-extract-plugin
export default {"container":"SettingsPanel_container__xQ50W","title":"SettingsPanel_title__aSFyc","label":"SettingsPanel_label__CCESh","gameTag":"SettingsPanel_gameTag__BmhIV"};